module.exports = __webpack_public_path__ + "static/media/crewstudio_app_login.dac033c9.jpg";